import { render, staticRenderFns } from "./ImgFallback2.vue?vue&type=template&id=cf3a4c8c&"
import script from "./ImgFallback2.vue?vue&type=script&lang=js&"
export * from "./ImgFallback2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf3a4c8c')) {
      api.createRecord('cf3a4c8c', component.options)
    } else {
      api.reload('cf3a4c8c', component.options)
    }
    module.hot.accept("./ImgFallback2.vue?vue&type=template&id=cf3a4c8c&", function () {
      api.rerender('cf3a4c8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8yTGsC3KNrZCa/JS/comp/ImgFallback2.vue"
export default component.exports